var _path, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructionsLargeDisplayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 144,
    viewBox: "0 0 226 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M125.305 46.885C126.081 46.979 126.819 46.3961 126.904 45.5968C127.358 41.2526 129.034 37.9992 131.863 35.9306C136.576 32.4891 143.276 33.1379 145.235 33.42V33.4294C145.198 33.4576 145.169 33.4764 145.131 33.5046C143.825 34.7176 142.51 35.9306 141.204 37.1436C140.693 37.6137 140.674 38.2249 141.147 38.7326C141.299 38.9019 141.459 39.0618 141.611 39.231C142.094 39.7388 142.699 39.767 143.21 39.2874C145.529 37.1436 147.838 35.0091 150.147 32.8652C150.223 32.79 150.299 32.7148 150.365 32.6207C150.649 32.1882 150.592 31.6992 150.204 31.2949C148.358 29.3203 146.504 27.3551 144.658 25.3805C144.346 25.042 144.034 24.7128 143.712 24.3743C143.248 23.8948 142.652 23.876 142.16 24.3179C141.98 24.506 141.8 24.6752 141.62 24.8445C141.138 25.2958 141.119 25.8976 141.564 26.3772C142.567 27.4397 143.57 28.5116 144.573 29.5742C144.838 29.8563 145.103 30.1384 145.406 30.4581L145.207 30.5051C144.573 30.4204 143.721 30.3358 142.718 30.3076C139.33 30.1948 134.239 30.6273 130.15 33.5986C126.62 36.1656 124.548 40.1055 124.008 45.3053C123.923 46.0952 124.5 46.8004 125.305 46.885Z",
    fill: "#14E6E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.75,
    y: 0.75,
    width: 94.5,
    height: 142.5,
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.75,
    y: 0.75,
    width: 91.5,
    height: 139.5,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 34,
    r: 7.25,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 34,
    r: 7.25,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 34,
    r: 10.25,
    fill: "#14E6E6",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 34,
    r: 10.25,
    fill: "#14E6E6",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 62,
    r: 7.25,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 62,
    r: 7.25,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 62,
    r: 7.25,
    fill: "white",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.595 20.567L165.971 14.0007",
    stroke: "#0000C2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.983 19.4925L184.329 12.8219",
    stroke: "#0000C2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 28.79L198.224 25.4339",
    stroke: "#0000C2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 140L63.5 142.5",
    stroke: "#0000C2",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.287 76.4498L186.287 69.7825C186.287 66.1004 189.272 63.1152 192.954 63.1151C196.636 63.115 199.621 66.1001 199.621 69.7822L199.622 80.8943",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.287 76.4498L186.287 69.7825C186.287 66.1004 189.272 63.1152 192.954 63.1151C196.636 63.115 199.621 66.1001 199.621 69.7822L199.622 80.8943",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.957 83.1153L212.957 74.2256C212.956 70.5435 209.971 67.5584 206.289 67.5585C202.607 67.5585 199.622 70.5437 199.622 74.2259L199.622 80.8931",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.957 83.1153L212.957 74.2256C212.956 70.5435 209.971 67.5584 206.289 67.5585C202.607 67.5585 199.622 70.5437 199.622 74.2259L199.622 80.8931",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.953 94.2297L172.952 38.6692C172.952 34.9871 175.937 32.0019 179.619 32.0018C183.301 32.0017 186.286 34.9868 186.286 38.669L186.287 76.4501",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.953 94.2297L172.952 38.6692C172.952 34.9871 175.937 32.0019 179.619 32.0018C183.301 32.0017 186.286 34.9868 186.286 38.669L186.287 76.4501",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.351 125.293C176.781 120.359 169.879 112.868 169.879 112.868C159.763 101.084 151.483 77.8519 151.483 77.8519C148.897 71.0985 157.422 68.2367 160.137 72.5131L163.836 78.6731L172.953 94.2299",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.351 125.293C176.781 120.359 169.879 112.868 169.879 112.868C159.763 101.084 151.483 77.8519 151.483 77.8519C148.897 71.0985 157.422 68.2367 160.137 72.5131L163.836 78.6731L172.953 94.2299",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.91 125.289C213.568 121.497 215.628 111.038 218.952 104.51C223.622 95.3367 224.914 83.3259 224.914 83.3259C224.914 79.6438 223.306 76.4471 219.624 76.4471C215.942 76.4472 212.957 79.4324 212.957 83.1145",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.91 125.289C213.568 121.497 215.628 111.038 218.952 104.51C223.622 95.3367 224.914 83.3259 224.914 83.3259C224.914 79.6438 223.306 76.4471 219.624 76.4471C215.942 76.4472 212.957 79.4324 212.957 83.1145",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.956 83.1172L212.956 85.3396",
    stroke: "#0000C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.305 46.885C129.081 46.979 129.819 46.3961 129.904 45.5968C130.358 41.2526 132.034 37.9992 134.863 35.9306C139.576 32.4891 146.276 33.1379 148.235 33.42V33.4294C148.198 33.4576 148.169 33.4764 148.131 33.5046C146.825 34.7176 145.51 35.9306 144.204 37.1436C143.693 37.6137 143.674 38.2249 144.147 38.7326C144.299 38.9019 144.459 39.0618 144.611 39.231C145.094 39.7388 145.699 39.767 146.21 39.2874C148.529 37.1436 150.838 35.0091 153.147 32.8652C153.223 32.79 153.299 32.7148 153.365 32.6207C153.649 32.1882 153.592 31.6992 153.204 31.2949C151.358 29.3203 149.504 27.3551 147.658 25.3805C147.346 25.042 147.034 24.7128 146.712 24.3743C146.248 23.8948 145.652 23.876 145.16 24.3179C144.98 24.506 144.8 24.6752 144.62 24.8445C144.138 25.2958 144.119 25.8976 144.564 26.3772C145.567 27.4397 146.57 28.5116 147.573 29.5742C147.838 29.8563 148.103 30.1384 148.406 30.4581L148.207 30.5051C147.573 30.4204 146.721 30.3358 145.718 30.3076C142.33 30.1948 137.239 30.6273 133.15 33.5986C129.62 36.1656 127.548 40.1055 127.008 45.3053C126.923 46.0952 127.5 46.8004 128.305 46.885Z",
    fill: "#14E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsLargeDisplayButton);
export default __webpack_public_path__ + "static/media/instructions_large_display_button.98497ec89307fa71af69b39dd492bab9.svg";
export { ForwardRef as ReactComponent };